module.exports = __webpack_public_path__ + "img/f_1_5.309abb29.png";